import React from 'react';
import { Header, MobileHeader } from './Header';
import { SubNav } from './SubNav';
import { SideNav } from './SideNav';
import { Footer } from './Footer';

export const Layout = ({
  page,
  children,
}) => (
  <div id="layout">
    <Header noprint={true} />
    <SubNav noprint={true} />
    <MobileHeader current={'/' + page } />
    <div id="middle">
      <div id="leftCol">
        <SideNav current={'/' + page} />
      </div>
      <div id="main">
        {children}
      </div>
    </div>
    <Footer noprint={true} />
  </div>
);
